import { Component, input, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-loader',
  templateUrl: './spinner-loader.component.html',
  standalone: true,
})
export class SpinnerLoaderComponent implements OnInit {
  size = input('tw-size-3.5 tw-border-[0.125rem]');
  ngOnInit(): void {}
}
